import { h } from '../lib/dom';
import { createAtomMark } from './atom';

export function renderHero(): HTMLElement {
  const tricolour = h('div', { class: 'tricolour', 'aria-hidden': 'true' },
    h('span', { class: 's' }),
    h('span', { class: 'w' }),
    h('span', { class: 'g' }),
  );

  const title = h('h1', { class: 'hero-title' });
  title.innerHTML = 'An engine for <span class="grad-text">public good</span>.';

  return h('section', { class: 'hero', 'aria-label': 'FunSource' },
    h('div', { class: 'container hero-stage reveal' },
      createAtomMark({ className: 'hero-mark' }),
      tricolour,
      title,
    ),
  );
}
